<template>
  <div>
    <div>
      <!-- 面包屑导航区域 -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>盘点</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card>
      <!-- 添加盘点信息按钮 -->
      <el-row>
        <el-col>
          <el-button type="primary" plain size="mini" icon="el-icon-plus" @click="handleAdd">新增</el-button>
        </el-col>
      </el-row>
      <!-- 商品信息表格 -->
      <!-- <el-button
        icon="el-icon-download"
        circle
        @click="getpdfyes"
        class="download"
        type="warning"
        size="medium"
      ></el-button> -->
      <el-table id="pdfDom" :data="inventoryList">
        <el-table-column label="编号" prop="ID" align="center"></el-table-column>
        <!-- <el-table-column label="盘点单号" prop="InventoryNO"></el-table-column> -->
        <el-table-column label="仓库" prop="WarehouseName" align="center"></el-table-column>
        <!-- <el-table-column label="盘点顺序" prop="InventorySort" width="120px"></el-table-column> -->
        <el-table-column label="状态" prop="CreateTime" align="center">
          <template slot-scope="scope">
            <!-- 0 未开始  1 进行中 2 已结束 -->
            <span v-if="scope.row.state === 1">进行中</span>
            <span v-else-if="scope.row.state === 2">已结束</span>
            <span v-else>未开始</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="备注" prop="Remark" width="250px"></el-table-column> -->
        <el-table-column label="操作" align="center">
          <template scope="scope">
            <!-- <el-button type="primary" icon="el-icon-edit" size="mini" @click="showEditDialog(scope)">编辑</el-button>
             -->
            <el-button icon="el-icon-thumb" type="text" size="mini" @click="open(scope.row)">库位状态</el-button>
            <el-button type="text" icon="el-icon-coin" size="mini" @click="inventoryStart(scope)">盘点</el-button>
            <el-button v-if="scope.row.state === 0" type="text" icon="el-icon-delete" size="mini"
              @click="removeType(scope)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 编辑盘点信息的会话框 -->
    <el-dialog title="修改盘点信息" :visible.sync="editDialogVisible" width="30%" @close="editDialogClose">
      <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
        <el-form-item label="盘点顺序" prop="InventorySort" required>
          <el-select v-model="editForm.InventorySort" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选择仓库" prop="WarehouseSet_ID" required>
          <el-select v-model="editForm.WarehouseSet_ID" placeholder="请选择">
            <el-option v-for="item in WareHouseList" :key="item.ID" :label="item.WarehouseName"
              :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="开始时间" prop="StartTime" required>
          <el-date-picker
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="editForm.StartTime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间" prop="EndTime" required>
          <el-date-picker
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="editForm.EndTime"
            placeholder="选择日期时间"
          >
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="备注" prop="Remark">
          <el-input v-model="editForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="editDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="editProduct">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加盘点信息的对话框 -->
    <el-dialog title="新增盘点信息" :visible.sync="addDialogVisible" width="25%" @close="addDialogClosed">
      <!-- 内容主体区域 -->
      <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="90px">
        <el-form-item label="选择仓库" prop="WarehouseSet_ID" required>
          <el-select v-model="addForm.WarehouseSet_ID" placeholder="请选择">
            <el-option v-for="item in WareHouseList" :key="item.ID" :label="item.WarehouseName"
              :value="item.ID"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="盘点顺序" prop="InventorySort" required>
          <el-select v-model="addForm.InventorySort" placeholder="请选择">
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="备注" prop="Remark">
          <el-input v-model="addForm.Remark" style="width: 90%" size="medium"></el-input>
        </el-form-item> -->
      </el-form>
      <!-- 底部区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="addDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="primary" @click="addInventory">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 查看盘点明细对话框 -->
    <el-dialog title="库位状态" :visible.sync="detailsDialogVisible" width="1000px" @close="detailsDialogClosed">
      <div style="display: flex;height: 100%;width: 100%;">
        <div v-if="imgUrl && imgUrl.length > 1"
          style="position: relative;flex: 1;width: 100%;display: flex;align-items: center;justify-content: center;">
          <img :src="$staticApi + imgUrl" style="position: absolute;object-fit: contain;width: 100%;height: 100%;" alt="" srcset="">
        </div>
        <div style="flex: 1;min-height: 500px;align-items: center;justify-content: center;" class="grid-28">
          <div v-for="(i, ind) in options" :key="i.key" class="grid-item">
            <div v-if="locationStatus[`warehouse${(+i.storageLocationNO)}`] === 1">
              <img src="../assets/pictures/tishicheng.png" class="round" alt="" srcset="">
            </div>
            <div v-else-if="locationStatus[`warehouse${(+i.storageLocationNO)}`] === 2">
              <img src="../assets/pictures/tishihong.png" class="round" alt="" srcset="">
            </div>
            <div v-else-if="locationStatus[`warehouse${(+i.storageLocationNO)}`] === 3">
              <img src="../assets/pictures/tishihong.png" class="round" alt="" srcset="">
            </div>
            <div v-else>
              <img src="../assets/pictures/tishihui.png" class="round" alt="" srcset="">
            </div>
            <div>{{ i.remark }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      getTypeList: {
        page: 1,
        limit: 100,
        privateKey: "12a5081e-e354-bada-3952-7a0df30d8849",
        appIdentification: "wms",
        tableName: "main_inventorydata",
      },
      // 盘点信息列表
      inventoryList: [],
      // 总数据条数
      total: 0,
      // 控制修改信息对话框的显示与隐藏
      editDialogVisible: false,
      // 控制添加信息对话框的显示与隐藏
      addDialogVisible: false,
      // 编辑用户信息的表单
      editForm: {},
      // 添加用户的表单数据
      addForm: {
        HomeSystem: "WMS",
        InventoryNo: "",
        InventorySort: "",
        // CreateTime: '',
        Remark: '',
        StartTime: "",
        EndTime: "",
        WarehouseSet_ID: "",
        // StorageInNO: '554656'
      },
      //添加表单的验证规则对象
      addFormRules: {
        // StorageLocation_ID: [
        //     { required: true, message: '请选择仓位', trigger: 'blur' }
        // ],
        // ProductSet_ID: [
        //     { required: true, message: '请选择产品', trigger: 'blur' },
        // ],
      },
      // 修改表单的验证规则对象
      editFormRules: {
        TypeName: [{ required: true, message: "请输入类型", trigger: "blur" }],
        CreateUser: [
          { required: true, message: "请输入创建人", trigger: "blur" },
        ],
      },
      // 仓库储位信息表
      storageList: {},
      // 产品信息表
      productSetingList: {},
      // 盘点顺序
      options: [
        {
          value: "0",
          label: "从小到大",
        },
        {
          value: "1",
          label: "从大到小",
        },
      ],
      //操作类型
      operationType: "3",
      // 盘点开始时间
      StartTime: "",
      onlyButton: "0",
      // 仓库信息
      WareHouseList: {},
      // 控制明细对话框显示与隐藏
      detailsDialogVisible: false,
      // 盘点明细信息表
      detailsList: {},
      // 库位状态
      locationStatus: {},
      options: [],
      statusTimer: null,
      fileList: [],
      imgUrl: "",
    };
  },
  created() {
    this.getType();
    // this.getTime()
    this.getStorageList();
    // this.getproductSetingList()
    this.getWareHouseList();
    this.init()
  },
  mounted() {
    //this.timer = setInterval(() => {
    this.getStorageList()
    //}, 2000);
    this.$once('hook:beforeDestroy', () => {
      this.timer && clearInterval(timer);
    })
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
    this.statusTimer && clearInterval(this.statusTimer);
  },
  methods: {
    // 打开添加的弹框
    handleAdd() {
      this.addDialogVisible = true
      this.fileList = []
    },
    // 上传文件
    async uploadImg() {
      const urlList = (this.fileList ?? []).filter(i => !i.raw).map(i => i.url)

      if (urlList && urlList[0]) { return false }

      if (this.fileList.length <= 0) {
        this.addForm.Remark = ""
        return false
      }

      const file = this.fileList[0]
      const formData = new FormData()

      formData.append('file', file.raw)

      const { data: res } = await await this.$http.post(
        "/WMS/upload",
        formData
      )

      this.addForm.Remark = res.data === 200 ? res.filePath : "";
    },
    handleRemove(_, fileList) {
      this.fileList = fileList;
    },
    handleChange(_, fileList) {
      this.fileList = fileList;
    },
    init(size = 28) {
      const array = new Array(size);
      const obj = {}
      for (let i = 0; i < array.length; i++) {
        array[i] = {
          label: `库位${i + 1}`,
          value: `warehouse${i + 1}`,
          key: i + 1,
          remark: `库位${i + 1}`,
        };
        obj[`warehouse${i + 1}`] = 0
      }
      this.options = array;
      this.locationStatus = obj;
    },
    // 调用接口获盘点信息
    async getType() {
      const { data: res } = await this.$http.get("/WMS/queryInventory", {
        params: this.getTypeList,
      });
      // console.log(res.data)
      const list = res.data || [];
      const array = [];
      list.map((i) => {
        if (i.state == 1) array.push(i);
      });
      array.push(...list);
      let uniqueArray = Array.from(
        array.reduce((map, obj) => map.set(obj.ID, obj), new Map()).values()
      );
      this.inventoryList = uniqueArray; //list.sort((a, b) => a.state - b.state)
    },
    // 调用接口删除盘点信息
    async removeType(scope) {
      const confirmResult = await this.$confirm(
        "此操作将永久删除该信息, 是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);

      if (confirmResult !== "confirm") {
        return this.$message.info("已经取消删除！");
      }

      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      params.append("tableName", this.getTypeList.tableName);
      const { data: res } = await this.$http.post("/WMS/GeneralDelete", params);
      // console.log(res);
      this.$message.success("删除成功！");
      this.getType();
    },
    // 展示修改产品的对话框
    async showEditDialog(scope) {
      this.editDialogVisible = true;
      let params = new URLSearchParams();
      params.append("ID", scope.row.ID);
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      params.append("tableName", this.getTypeList.tableName);
      const { data: res } = await this.$http.get("/WMS/GeneralQueryID", {
        params,
      });
      // console.log(res.data);
      if (res.data[0].InventorySort == "0") {
        res.data[0].InventorySort = "从小到大";
      }
      if (res.data[0].InventorySort == "1") {
        res.data[0].InventorySort = "从大到小";
      }
      this.editForm = res.data[0];
    },
    // 监听修改信息对话框的关闭事件
    editDialogClose() {
      this.$refs.editFormRef.resetFields();
    },
    //  监听添加信息对话框的关闭事件
    addDialogClosed() {
      this.$refs.addFormRef.resetFields();
    },
    // 监听明细信息对话框的关闭事件
    detailsDialogClosed() {
      this.$refs.editFormRef?.resetFields();
      this.statusTimer && clearInterval(this.statusTimer)
    },
    // 调用接口新增盘点信息
    addInventory() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();
        // params.append("privateKey", this.getTypeList.privateKey)
        // params.append("appIdentification", this.getTypeList.appIdentification)
        // params.append("HomeSystem", this.addForm.HomeSystem)
        // params.append("InventorySort", this.addForm.InventorySort)
        // params.append("Remark", this.addForm.Remark)
        params.append("WID", this.addForm.WarehouseSet_ID);
        // 可以发起添加用户的网络请求
        const { data: res } = await this.$http.post(
          "/WMS/inventoryTable",
          params
        );
        if (res == -2) {
          return this.$message.error("系统异常！");
        }
        if (res == -4) {
          return this.$message.error("盘点单创建失败！");
        }
        if (res == -5) {
          return this.$message.error("仓库下未创建库位不可盘点！");
        }
        if (res == -6) {
          return this.$message.error("仓该仓库下盘点任务未结束！");
        }
        this.$message.success("添加盘点信息成功！");
        this.getType();
        // 隐藏添加用户的对话框
        this.addDialogVisible = false;
        // 重新获取用户列表数据
        this.getType();
      });
    },
    // 调用接口编辑盘点信息
    editProduct() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (!valid) return;
        let params = new URLSearchParams();
        params.append("privateKey", this.getTypeList.privateKey);
        params.append("appIdentification", this.getTypeList.appIdentification);
        params.append("HomeSystem", this.editForm.HomeSystem);
        params.append("ID", this.editForm.ID);
        params.append("InventorySort", this.editForm.InventorySort);
        // params.append("StartTime", this.editForm.StartTime)
        // params.append("EndTime", this.editForm.EndTime)
        params.append("WarehouseSet_ID", this.editForm.WarehouseSet_ID);
        params.append("Remark", this.editForm.Remark);
        const { data: res } = await this.$http.post(
          "/WMS/updateInventoryManagement",
          params
        );
        if (res !== 1) {
          return this.$message.error("更新盘点息失败！");
        }
        // 关闭对话框
        this.editDialogVisible = false;
        // 刷新数据列表
        this.getType();
        // 提示修改成功
        this.$message.success("更新入库信息成功！");
      });
    },
    // 调用接口获取仓库储位信息
    async getStorageList() {
      const { data: res } = await this.$http.get("/WMS/queryStorageLocation", {
        params: this.getTypeList,
      });
      // console.log(res.data);
      this.storageList = res.data;
      this.init(res.data.length)
    },
    // 调用接口获取产品信息
    async getproductSetingList() {
      const { data: res } = await this.$http.get("/WMS/queryProductSet", {
        params: this.getTypeList,
      });
      // console.log(res.data);
      this.productSetingList = res.data;
    },
    // 获取当前时间
    getTime() {
      var _this = this;
      let yy = new Date().getFullYear();
      let mm = new Date().getMonth() + 1;
      let dd = new Date().getDate();
      let hh = new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      _this.time = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      // console.log(_this.time);
      this.StartTime = _this.time;
    },
    // 点击按钮开始盘点
    async inventoryStart(scope) {
      const confirmResult = await this.$confirm(
        "盘点操作已开始，请勿重复点击！",
        "提示",
        {
          confirmButtonText: "确定",
          type: "warning",
        }
      ).catch((err) => err);
      let params = new URLSearchParams();
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      params.append("ID", scope.row.ID);
      params.append("operationType", this.operationType);
      params.append("StartTime", this.StartTime);
      // console.log('xxxxxxxxxxxxxx')
      // console.log('0' + params)
      const { data: res } = await this.$http.post("/WMS/OperationType", params);
      console.log(res);
    },
    getpdfyes() {
      this.getPdf();
    },
    //调用接口获取仓库信息
    async getWareHouseList() {
      const { data: res } = await this.$http.get("/WMS/queryWareHouse", {
        params: this.getTypeList,
      });
      // console.log(res.data);
      this.WareHouseList = res.data;
    },
    // 调用接口获取产品明细
    async details(scope) {
      let params = new URLSearchParams();
      params.append("privateKey", this.getTypeList.privateKey);
      params.append("appIdentification", this.getTypeList.appIdentification);
      params.append("limit", this.getTypeList.limit);
      params.append("page", this.getTypeList.page);
      params.append("InventoryNO", scope.row.InventoryNO);
      // console.log("123" + params);
      const { data: res } = await this.$http.get(
        "/WMS/inventoryManagementDetails",
        { params }
      );
      // console.log(res);
      this.detailsList = res.data;
    },
    async warehousHandler(row) {
      const { data } = await this.$http.get("/WMS/selStorageLocation?WarehouseName=" + row.WarehouseName)
        .catch(() => { })

      if (data.code == 200) {
        this.options = data.success_msg
      } else {
        this.$message({
          type: "error",
          message: `库位查询失败`,
        });
      }
    },
    async open(row) {
      await this.warehousHandler(row)

      const array = this.WareHouseList

      for (let i = 0; i < array.length; i++) {
        const element = array[i];

        if(element.ID === row.WID) {
          this.imgUrl = element.Remark
          break;
        }
      }

      this.detailsDialogVisible = true;

      this.statusTimer && clearInterval(this.statusTimer)

      this.statusTimer = setInterval(() => {
        this.getLocationStatus(row);
      }, 1000);
    },
    async getLocationStatus(row) {
      try {
        const { data: res } = await this.$http.post("/WMS/redis_storage_take");
        if (res.code === 1) {
          this.locationStatus = res.success_msg.dataTag
        }
      } catch (error) { }
    },
  },
};
</script>

<style lang="less" scoped>
.download {
  position: sticky;
  transform: translate(35%, -140%);
}

.grid-28 {
  width: 100%;
  // height: 500px;
  // display: grid;
  // grid-template-rows: repeat(4, 1fr);
  // grid-template-columns: repeat(7, 1fr);
  // gap: 8px;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}

.grid-item {
  // width: 100%;
  // height: 100%;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  // justify-content: center;
  width: auto;
  display: inline-block;
  text-align: center;
  margin: 8px;

  .round {
    width: 80px;
    height: 80px;
    border-radius: 50%;
  }

  .false {
    background: radial-gradient(white, #999);
  }

  .true {
    background: radial-gradient(white, red);
  }

  .yellow {
    background: radial-gradient(white, yellow);
  }
}
</style>
